<script>
export default {
    name: "MultipleChoiceQuestion",
    data() {
        return {
            selectedOption: null,
        }
    },
    methods: {
        checkAnswer() {
            this.$emit('checkInput', this.selectedOption)
        }
    },
    props: {
        question: {
            type: Object,
            required: true
        },
        buttonLabel: {
            type: String,
            default: 'Check Answer'
        }
    }
}
</script>

<template>
    <div>
        <div class="quiz-question quiz-question-multiple-choice">
            <div class="form-check"
                 v-for="option in question.questionTypeData.options"
                 :key="option.id"
            >
                <input
                    class="form-check-input"
                    type="radio"
                    :name="`question-${question.id}`"
                    :value="option.id"
                    :id="`option-${option.id}`"
                    v-model="selectedOption"
                >
                <label class="form-check-label" :for="`option-${option.id}`">{{ option.answer }}</label>
            </div>
            <button type="button" class="btn btn-secondary mt-3" @click="checkAnswer()">{{ buttonLabel }}</button>
        </div>
    </div>
</template>
